module.exports = __webpack_public_path__ + "static/img/ARAD-S2_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/ARAD-S2_1.png
// module id = Q0L+
// module chunks = 0